<template>
  <div class="materials-page">
    <div class="page-intro">
      <div><h1>素材库管理</h1><p>插花素材与个人 2D / 3D 素材统一管理</p></div>
      <router-link class="ai-link" to="/ai3d">AI 生成 3D 素材</router-link>
    </div>
    <div class="library-switch">
      <button type="button" :class="{ active: library === 'flower' }" @click="library = 'flower'">插花素材库</button>
      <button type="button" :class="{ active: library === 'environment' }" @click="library = 'environment'">2D 花艺环境素材库</button>
      <button type="button" :class="{ active: library === 'landscape' }" @click="library = 'landscape'">现代花艺 / 园林景观 · 3D</button>
    </div>
    <div class="library-panel" v-if="library === 'flower'">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="flower" label="花材管理"></el-tab-pane>
        <el-tab-pane name="container" label="器皿管理"></el-tab-pane>
      </el-tabs>
      <router-view></router-view>
    </div>
    <div v-else class="library-pending">当前素材库将在接口接入后显示</div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            activeName:'flower',
            library:'flower'
        }
    },
    watch: {
        '$route.path'(path) {
            if (path.includes('/materials/')) {
                this.library = 'flower';
                this.activeName = path.includes('/container/') ? 'container' : 'flower';
            }
        }
    },
    methods:{
        handleClick(item){
            this.$router.push(`/materials/${item.name}/list`);
        }
    }
};
</script>

<style lang="scss" scoped>
.page-intro { display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; margin-bottom: 24px; }
.page-intro h1 { font-size: 28px; font-weight: 700; }
.page-intro p { margin-top: 8px; color: #89948d; font-size: 14px; }
.ai-link { display: inline-flex; align-items: center; min-height: 42px; padding: 0 18px; border-radius: 11px; color: #fff; background: #21965b; font-size: 14px; font-weight: 650; white-space: nowrap; }
.ai-link:hover { color: #fff; background: #18854e; }
.library-switch { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 18px; }
.library-switch button { min-height: 42px; padding: 0 18px; border: 1px solid #e1eae3; border-radius: 11px; color: #59645e; background: #fff; font-size: 14px; cursor: pointer; }
.library-switch button.active { border-color: #bde4cc; color: #21965b; background: #eaf8f0; font-weight: 650; }
.library-panel { padding: 20px; border: 1px solid #e8eee9; border-radius: 18px; background: #fff; }
.library-pending { padding: 90px 20px; border: 1px solid #e8eee9; border-radius: 18px; color: #89948d; background: #fff; font-size: 14px; text-align: center; }
@media (max-width: 700px) { .page-intro { flex-direction: column; } }
</style>
